import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';

import { KnowledgeBaseArticle } from 'src/models';
import { ENTITY_TYPES } from 'src/models/entities';
import { UserGroup } from 'src/models/user-groups';
import { SearchablePopoverService } from 'src/services/searchable-popover.service';

@Component({
  selector: 'app-bulk-manage-groups',
  templateUrl: './bulk-manage-groups.component.html',
  styleUrls: ['./bulk-manage-groups.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class BulkManageGroupsComponent implements OnInit {
  @Input() articles: Partial<KnowledgeBaseArticle>[] = [];
  @Input() availableGroups: UserGroup[] = [];

  initialSelectedGroupIds = new Set<string>();
  selectedGroupsMap = new Map<string, UserGroup>();
  articleIds: string[] = [];

  constructor(
    private modalCtrl: ModalController,
    private searchablePopoverService: SearchablePopoverService,
  ) {}

  ngOnInit(): void {
    if (!this.articles || this.articles.length === 0) {
      console.warn('BulkManageGroupsComponent: No articles provided.');
      this.dismissModal();
      return;
    }

    this.articleIds = this.articles.map((a) => a.id).filter((id): id is string => !!id);

    const unionGroupIds = new Set<string>();
    for (const article of this.articles) {
      (article.userGroupIds ?? []).forEach((groupId) => {
        unionGroupIds.add(groupId);
      });
    }

    this.initialSelectedGroupIds = unionGroupIds;

    this.selectedGroupsMap.clear();
    this.initialSelectedGroupIds.forEach((id) => {
      const group = this.availableGroups.find((g) => g.id === id);
      if (group) {
        this.selectedGroupsMap.set(id, group);
      }
    });
  }

  addGroup(event: MouseEvent) {
    const currentlySelectedIds = Array.from(this.selectedGroupsMap.keys());
    this.searchablePopoverService.entities({
      event,
      type: ENTITY_TYPES.USER_GROUP,
      excludeIds: currentlySelectedIds,
      callback: (id: string, name: string, selectedGroup: UserGroup | null) => {
        if (id && selectedGroup && !this.selectedGroupsMap.has(id)) {
          this.selectedGroupsMap.set(id, selectedGroup);
        }
      },
    });
  }

  removeGroup(groupId: string) {
    if (this.selectedGroupsMap.has(groupId)) {
      this.selectedGroupsMap.delete(groupId);
    }
  }

  get selectedGroupsArray(): UserGroup[] {
    return Array.from(this.selectedGroupsMap.values());
  }

  trackByGroupId(index: number, group: UserGroup): string {
    return group.id;
  }

  dismissModal(): void {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  applyChanges(): void {
    const result = {
      articleIds: this.articleIds,
      finalGroupIds: Array.from(this.selectedGroupsMap.keys()),
    };
    this.modalCtrl.dismiss(result, 'apply');
  }
}
